import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Loader from 'react-loader';

import Table from './Table';
import Controls from './Controls';
import Expander from './Expander';

class DataDisplay extends Component {
	constructor(props) {
		super(props);

		this.state = {
			default: true,
		};

		this.getExpanderValid = this.getExpanderValid.bind(this);
	}
	getExpanderValid() {
		// if (this.props.isLoaded && this.props.headerSelection.length > 0) {
		// 	return "valid"
		// } else if (this.props.isLoaded && this.props.filename.length > 0 && this.props.headerSelection.length === 0) {
		// 	return "invalid";
		// }

		return "";
	}
	render() {
		let children = [
			<Controls
				key="0" 
				fileId={this.props.fileId}
				filename={this.props.filename}
				isLoaded={this.props.isLoaded}
				hasHeaders={this.props.headersExist}
				headers={this.props.headers}
				headerSelection={this.props.headerSelection}
				dispatch={this.props.dispatch}
				formula={this.props.formula}
				firstRow={this.props.firstRow}
				axisLabel={this.props.axisLabel}
		/>];

		if (this.props.data && this.props.data.length > 0) {
			children.push(<section className="dataview">
				<Table 
					key="1"
					data={this.props.data}
					headers={this.props.headers} />
			</section>);
		}

		return (
			<Expander title={this.props.title + " - (" + this.props.axisLabel + ")"} className={this.getExpanderValid()}>
				<Loader 
					loaded={!this.props.isLoading}
					className="loader"
				>
					{children}
				</Loader>
			</Expander>
		);
	}
}

DataDisplay.propTypes = {
	fileId: PropTypes.string,
	title: PropTypes.string,
	data: PropTypes.array,
	headers: PropTypes.array,
	isLoading: PropTypes.bool,
	filename: PropTypes.string,
	isLoaded: PropTypes.bool,
	headersExist: PropTypes.bool,
	headerSelection: PropTypes.array,
	dispatch: PropTypes.func,
	formula: PropTypes.string,
	firstRow: PropTypes.array,
	axisLabel: PropTypes.string,
};

export default DataDisplay;


// WEBPACK FOOTER //
// ./src/components/DataDisplay.js